import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-credits',
  templateUrl: 'credits.html'
})
export class Credits{

  constructor(public navCtrl: NavController, public navParams: NavParams) {}
  
}



// WEBPACK FOOTER //
// ./src/pages/credits/credits.ts